/** Classes de alinhamento compartilhadas nas listagens do sistema */

const TH_BASE = "px-2 py-2 font-semibold text-gray-900 align-middle";
const TD_BASE = "px-2 py-2 align-middle";

/** Cabeçalho de coluna (títulos sempre centralizados) */
export const listagemTh = `${TH_BASE} text-center`;
/** @deprecated Use listagemTh — mantido para compatibilidade */
export const listagemThLeft = listagemTh;
export const listagemThCenter = listagemTh;

/** Célula: nomes, cidades, estados, descrições, e-mail, etc. */
export const listagemTdLeft = `${TD_BASE} text-left`;
/** Célula: ID, números, moeda, datas, status */
export const listagemTdCenter = `${TD_BASE} text-center`;

/** shadcn TableHead / TableCell */
export const tableHeadLeft = "text-left";
export const tableHeadCenter = "text-center";
export const tableCellLeft = "text-left";
export const tableCellCenter = "text-center";

/** Centraliza badge ou grupo de botões dentro de célula */
export const listagemCenterWrap = "flex justify-center";
